import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { IAuthContextProps, withAuthContext } from "../components/with-auth-context";
import { AdvancedSearchComponent } from "./advanced-search";
import { withSnackbar, ISnackbarContextProps } from "../components/with-snackbar";

interface IArchivedContentPageComponentState {
    
}

type ArchivedContentPageComponentProps = RouteComponentProps<any> & IAuthContextProps & ISnackbarContextProps;

class ArchivedContentPageComponent extends React.Component<ArchivedContentPageComponentProps, IArchivedContentPageComponentState> {
    constructor(props: ArchivedContentPageComponentProps) {
        super(props);
    }
    public render() {
        return <AdvancedSearchComponent {...this.props} deletedOnly={true} />
    }
}


export const ArchivedContentPage = withSnackbar(withAuthContext(ArchivedContentPageComponent));


// WEBPACK FOOTER //
// ./src/pages/archived-content-page.tsx